import React, { useEffect, useRef } from "react";
import { useAcceptPrivacyPolicyMutation, useGetPrivacyPolicyStatusQuery } from "../api/privacyPolicyApiSlice";
import { useDispatch } from "react-redux";
import { logOut } from "features/auth/authSlice";
import { useTranslation } from "react-i18next";
//import "bootstrap/dist/css/bootstrap.min.css";
//import "bootstrap/dist/js/bootstrap.bundle.min.js";

export default function PrivacyPolicyPopup() {

    const { t } = useTranslation("global")
    const timestampRef = useRef(Date.now()).current;
    const dispatch = useDispatch()

    let modalInstance;

    //API
    const {
        data: privacyPolicyStatus,
        isFetching: isFetching,
        isLoading: isLoading,
        isSuccess: isSuccess,
        isError: isError,
        error: error
    } = useGetPrivacyPolicyStatusQuery({ sessionId: timestampRef })

    const [acceptPrivacyPolicy] = useAcceptPrivacyPolicyMutation()


    useEffect(() => {
        if (isSuccess && !privacyPolicyStatus.accepted) {
            // Apri la modale usando Bootstrap
            const modalElement = document.getElementById("staticBackdrop");
            if (modalElement) {
                modalInstance = new window.bootstrap.Modal(modalElement);
                modalInstance.show();
            }
        }
    }, [privacyPolicyStatus]); // L'array di dipendenze assicura che l'effetto venga eseguito solo quando la condizione cambia

    function handleAccept() {
        acceptPrivacyPolicy()
        document.getElementById("close-privacy-button").click()
    }

    const handleLogoutRequest = async (e) => {
        console.log("Requested Logout by Button")
        dispatch(logOut({}))
        document.getElementById("close-privacy-button").click()
    }

    return (
        <>

            {
                isSuccess && !privacyPolicyStatus.accepted &&
                <div
                    className="modal fade"
                    id="staticBackdrop"
                    data-bs-backdrop="static"
                    data-bs-keyboard="false"
                    tabIndex="-1"
                    aria-labelledby="staticBackdropLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                        <div className="modal-content bg-dark">
                            <div className="modal-header">
                                <h1 className="modal-title fs-5" id="staticBackdropLabel">
                                    Privacy Policy
                                </h1>
                                <button
                                    id="close-privacy-button"
                                    type="button"
                                    className="btn-close"
                                    style={{ display: "none" }}
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                ></button>
                            </div>
                            <div className="modal-body">

                                <span style={{ whiteSpace: "pre-line" }}>{privacyPolicyStatus.privacyPolicyDto.text}</span>



                                <div className="mt-3">
                                    <strong>{t("property.updated_at")} </strong> {new Date(privacyPolicyStatus.privacyPolicyDto.updatedAt).toLocaleString()}
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => handleLogoutRequest()}>
                                    {t("action.close")}
                                </button>
                                <button type="button" className="btn btn-primary" onClick={() => handleAccept()}>
                                    <i className="fa-solid fa-check"></i> {t("action.accept")}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            }
        </>

    );
}
